import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { CaseService } from '../../services/case.service';
import { SharedHttpService } from '../../services/shared-http.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-case-penalties',
  templateUrl: './case-penalties.component.html',
  styleUrls: ['./case-penalties.component.scss']
})
export class CasePenaltiesComponent implements OnInit {
  CasePenaltiesList: any;
  caseObject: any;
  @Input() loadDataFP: Observable<any>;

  constructor(public caseService: CaseService, public sharedService: SharedHttpService, public router: Router, private modalService: NgbModal) {

  }
  ngOnInit(): void {
    this.loadDataFP.subscribe((data) => {
      setTimeout(() => {
this.loadData();
      }, 100);

  });
  }


  loadData() {
    this.caseObject = this.caseService.getCaseData();

    let getList: any = `api/CasePenalty/GetCasePenalties?eCaseId=${this.caseObject.eCaseId}`;
    this.sharedService.get(getList).subscribe(result => {
      console.log("CasePenaltiesList", result);
      this.CasePenaltiesList = result;


    });
  }
}
